import React, { useEffect, useState, ChangeEvent } from 'react';
import COTable from 'shared/components/COTable';
import style from './ProcessingFacility.module.scss';
import ValueChainService from 'services/ValueChainService/valuechain.service';
import { getColumns } from './ProcessingFacilityColumns';
import COPagination from 'shared/components/COPagination';
import COSearch from 'shared/components/COSearch';
import { SearchProps } from 'enums/ProductsViewEnums';
import { searchUtil } from 'shared/utils/SearchUtil';
import { ProcessingFacility } from 'models/ProcessingFacility/ProcessingFacility.model';

const ProcessingFacilityList: React.FC = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const {
    fetchProcessingFacilities,
    processingFacilityList,
    loading,
    currentPage,
    totalItems,
    buttonLoading,
  } = ValueChainService();
  useEffect(() => {
    fetchProcessingFacilities({ size: 20, from_value_chain: true });
  }, []);

  const columns = getColumns();
  const [, setTableData] = React.useState<ProcessingFacility[]>(
    processingFacilityList ?? []
  );
  useEffect(() => {
    setTableData(processingFacilityList);
  }, []);

  useEffect(() => {
    localStorage.removeItem('create-processing-facility');
    localStorage.removeItem('scope1');
    localStorage.removeItem('scope2');
  }, []);

  const handlePaginationChange = (page: number, pageSize: number) => {
    fetchProcessingFacilities({
      page: page,
      size: pageSize,
      from_value_chain: true,
    });
  };
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    const searchValue = e.target.value;
    searchUtil((searchVal: string) => {
      fetchProcessingFacilities({
        name: searchVal,
        size: 20,
        from_value_chain: true,
      });
    })(searchValue);
  };

  return (
    <div>
      <div className={style.searchContainer}>
        <COSearch
          name={SearchProps.SEARCH_NAME}
          placeholderString={SearchProps.PLACEHOLDER_STRING}
          inputValue={searchValue}
          handleChange={handleInputChange}
        />
      </div>
      <div className={style.paginationContainer}>
        <COPagination
          onChange={handlePaginationChange}
          total={totalItems}
          current={currentPage}
        />
      </div>

      <COTable
        columns={columns}
        loading={loading || buttonLoading}
        data={processingFacilityList}
      />
    </div>
  );
};

export default ProcessingFacilityList;
